// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__6ii7D","selects":"Documents_selects__3FFJu"};